<template>
  <v-dialog
    v-model="show"
    max-width="900px"
  >
    <v-card>
      <v-card-title>
        Request For Medical Insurance
        <v-spacer></v-spacer>
        <v-btn
          icon
          blur
          @click.prevent="show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <v-expansion-panels v-model="firstPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Attached files</v-expansion-panel-header>
            <v-expansion-panel-content>
              Please upload the documents:<br/>
                1. Signed by yourself insurance agreement.<br/>
                2. Payment check.<br/>
                3. Any other related to the transaction document.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mb-2">
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Agreement"
              v-model="insuranceAgreementFile.file"
              @change="onInsuranceAgreementFileChange"
              show-size
              counter
              accept=".doc, .docx, application/pdf, .jpg, application/msword, image/jpg"
              :rules="[otherAndInsuranceHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Payment check"
              v-model="paymentCheckFile.file"
              @change="onPaymentCheckFileChange"
              show-size
              counter
              accept=".doc, .docx, application/pdf, .jpg, application/msword, image/jpg"
              :rules="[checkAndInsuranceHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4">
            <v-file-input
              label="Other (optional)"
              v-model="otherFile.file"
              @change="onOtherFileChange"
              show-size
              counter
              accept=".doc, .docx, application/pdf, .jpg, application/msword, image/jpg"
              :rules="[otherAndCheckHaveDifferentNames||'Please, don\'t send 2 identical files']"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-expansion-panels v-model="secondPanel">
          <v-expansion-panel>
            <v-expansion-panel-header class="ml-0">Other fields</v-expansion-panel-header>
            <v-expansion-panel-content>
              How much did you pay for the insurance (UAH)?
                Are there some additional details?
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
          <v-col cols="12" lg="4" md="4">
            <v-text-field
              v-model="computedAmountSpent"
              class="inputAmount"
              label="Amount spent"
              type="number"
              hint="Enter amount spent (<= 150 USD per year)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="8" md="8">
            <v-textarea
              v-model="details"
              rows="1"
              label="Details (optional)"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small :disabled="!isRequestReady() || !isRequestAppropriate" @click="sendRequest" color="primary">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MedicalInsuranceRequest',
  props: {
    value: {
      required: true,
      default: false
    }
  },
  data () {
    return {
      isRequestAppropriate: true,
      firstPanel: 0,
      secondPanel: 0,
      insuranceAgreementFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      paymentCheckFile: {
        file: null,
        File_Name: '',
        File_Type: ''
      },
      otherFile: {
        file: null,
        File_Name: null,
        File_Type: null
      },
      amountSpent: null,
      details: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (this.value) {
          this.clearAll()
          this.isRequestAppropriate = true
        }
      }
    },
    otherAndInsuranceHaveDifferentNames () {
      if (!this.otherFile.File_Name || !this.insuranceAgreementFile.File_Name) {
        return true
      }
      return this.otherFile.File_Name !== this.insuranceAgreementFile.File_Name
    },
    checkAndInsuranceHaveDifferentNames () {
      if (!this.paymentCheckFile.File_Name || !this.insuranceAgreementFile.File_Name) {
        return true
      }
      return this.paymentCheckFile.File_Name !== this.insuranceAgreementFile.File_Name
    },
    otherAndCheckHaveDifferentNames () {
      if (!this.otherFile.File_Name || !this.paymentCheckFile.File_Name) {
        return true
      }
      return this.otherFile.File_Name !== this.paymentCheckFile.File_Name
    },
    user () {
      return this.$store.getters.getUser
    },
    computedAmountSpent: {
      get () {
        return this.amountSpent
      },
      set (val) {
        if (val < 0) {
          this.amountSpent = -val
        } else {
          this.amountSpent = val
        }
      }
    }
  },
  methods: {
    sendRequest () {
      this.isRequestAppropriate = false
      this.axios.post('/api/requests/medical_insurance',
        {
          Creator_ID: this.user.employee_id,
          Agreement_File: this.insuranceAgreementFile,
          Payment_Check_File: this.paymentCheckFile,
          Other_File: this.otherFile,
          Amount_Spent: this.amountSpent,
          Details: this.details
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Request for medical insurance was made' })
      }).catch(error => {
        this.isRequestAppropriate = true
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onInsuranceAgreementFileChange (e) {
      this.onFileChange(e, this.insuranceAgreementFile)
    },
    onPaymentCheckFileChange (e) {
      this.onFileChange(e, this.paymentCheckFile)
    },
    onOtherFileChange (e) {
      this.onFileChange(e, this.otherFile)
    },
    onFileChange (e, file) {
      if (e) {
        const reader = new FileReader()
        reader.onload = () => {
          file.file.data = reader.result
          let binary = ''
          const bytes = new Uint8Array(file.file.data)
          const len = bytes.byteLength
          for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          file.file.base64String = `data:${e.type};base64, ${window.btoa(binary)}`
        }
        file.File_Name = e.name
        file.File_Type = e.type
        reader.readAsArrayBuffer(e)
      }
    },
    isRequestReady () {
      return this.insuranceAgreementFile.file &&
        this.paymentCheckFile.file &&
        this.computedAmountSpent
    },
    clearAll () {
      this.insuranceAgreementFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.paymentCheckFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.otherFile = {
        file: null,
        File_Name: '',
        File_Type: ''
      }
      this.computedAmountSpent = null
      this.details = null
    }
  }
}
</script>
<style>
.inputAmount input[type='number'] {
    -moz-appearance:textfield;
}
.inputAmount input::-webkit-outer-spin-button,
.inputAmount input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
